import React from 'react';
import './css/EventDetailsSkeletonLoader.css';

function EventDetailsSkeletonLoader() {
  return (
    <div className="skeleton-loader">
      <div className="skeleton-box"></div>
      <h3 className="skeleton-section-title"></h3>
      <div className="skeleton-button"></div>
      <div className="skeleton-button"></div>
      <div className="skeleton-button"></div>
    </div>
  );
}

export default EventDetailsSkeletonLoader;